<template>
  <div>
    <button
      :class="[
      { 'active' : isActiveVariant(variants[0].id) && $route.meta.category === config.rootcategories.drukowanie },
      { 'active_office' : isActiveVariant(variants[0].id) && $route.meta.category === config.rootcategories.biuro }]"
      class="mr10 bg-cl-primary brdr-1 brdr-cl-primary brdr-square h5 cl-tertiary generic-selector"
      @click="$emit('change', variants[0])"
      :aria-label="$t('Select ' + variant.label)"
    >
      {{ $t('Nie') || "Nie" }}
    </button>
    <button
      :class="[
      { 'active' : isActiveVariant(variants[1].id) && $route.meta.category === config.rootcategories.drukowanie },
      { 'active_office' : isActiveVariant(variants[1].id) && $route.meta.category === config.rootcategories.biuro }]"
      class="bg-cl-primary brdr-1 brdr-cl-primary brdr-square h5 cl-tertiary generic-selector"
      @click="$emit('change', variants[1])"
      :aria-label="$t('Select ' + variant.label)"
    >
      {{ $t("Tak") || "Tak" }}
    </button>
  </div>
</template>

<script>
import config from 'config';
import filterMixin from 'theme/mixins/filterMixin.ts';


export default {
  mixins: [filterMixin],
  data () {
    return {
      config,
      variants: [{
        id: "0",
        label: "0",
        type: this.variant.type
      }, {
        id: "1",
        label: "1",
        type: this.variant.type
      }]
    }
  },
  methods: {
    isActiveVariant (id) {
      const selectedVariantFilter = this.selectedFilters[this.variant.type]
      if (!selectedVariantFilter) return false
      if (Array.isArray(selectedVariantFilter)) return !!selectedVariantFilter.find(variant => variant.id === id)
      return toString(selectedVariantFilter.id) === toString(id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-active: color(secondary);
  $color-disabled: color(secondary, $colors-border);

  .generic-selector {
    height: 40px;
    padding-left: 8px;
    padding-right: 8px;
    min-width: 50px;

    &:hover,
    &:focus {
      border-width: 2px;
    }

    &.active {
      border-color: $pink;
      border-width: 2px;
      color: $color-active;
    }

    &.active_office {
      border-color: $office-primary;
      border-width: 2px;
      color: $color-active;
    }

    &:disabled {
      border-color: $color-disabled;
      color: $color-disabled;
      cursor: not-allowed;

      &:hover,
      &:after {
        border-width: 1px;
      }
    }
  }
</style>
